const state = {
    user_id: '1',
    tenant_id: '1',
    branchManagerKey: 0,
    branch_or_warehouse_id: null,
    branch_or_warehouse_name: '',
    branch_or_warehouse_info: [],
};

const getters = {
    getBranchOrWarehouseId(state) {
        return state.branch_or_warehouse_id;
    },
    getBranchOrWarehouseInfo(state) {
        return state.branch_or_warehouse_info;
    },
    getUserId(state) {
        return state.user_id;
    },
    getBranchOrWarehouseName(state) {
        return state.branch_or_warehouse_name;
    },
    getTenantId(state) {
        return state.tenant_id;
    },
    getBranchManagerKey(state) {
        return state.branchManagerKey;
    }
};

const mutations = {
    SET_BRANCH_OR_WAREHOUSE_ID(state, payload) {
        state.branch_or_warehouse_id = payload;
    },
    
    SET_BRANCH_OR_WAREHOUSE_INFO(state, payload) {
        state.branch_or_warehouse_info = payload;
    },

    SET_BRANCH_OR_WAREHOUSE_NAME(state, payload) {
        state.branch_or_warehouse_name = payload;
    },

    INC_BRANCH_MANAGER_KEY(state) {
        state.branchManagerKey++;
    },
};

const actions = {
    async setBranchOrWarehouseId({ commit, state }, payload) {
        commit('SET_BRANCH_OR_WAREHOUSE_ID', payload);
    },

    async setBranchOrWarehouseInfo({ commit, state }, payload) {
        commit('SET_BRANCH_OR_WAREHOUSE_INFO', payload);
    },

    async setBranchOrWarehouseName({ commit, state }, payload) {
        commit('SET_BRANCH_OR_WAREHOUSE_NAME', payload);
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
